



























import {Vue, Component} from 'vue-property-decorator'
import {Action, State} from 'vuex-class'
import Utils from '@/utils'
import {PopupState} from '@/store'
import DateHelper from '@/lib/DateHelper'
import {Report} from '@/lib/kepler/interfaces'
import VehicleReport from '../components/entities/vehicle/VehicleReport.vue'
import VehicleAddReport from '@/views/Vehicle/VehicleAddReport.vue'

@Component({
  components: {
    FilteredListWithAddButton: Utils.loadComponent('FilteredListWithAddButton'),
    CheckBox: Utils.loadComponent('proxy/Inputs/CheckBox'),
    CardButton: Utils.loadComponent('CardButton'),
    Flex: Utils.loadComponent('proxy/Flex'),
    Img: Utils.loadComponent('proxy/Image'),
  },
  name: 'Reportings',
})
export default class Reportings extends Vue {
  @State((state) => state.profile.reports) public reports!: Report[]
  @Action('openPopup') protected openPopup!: any
  @Action('setActionButtons') protected setActionButtons: any

  protected show: string[] = []

  protected get filteredReports() {
    return this.reports.filter((r) => {
      if (this.show.includes(r.status)) {
        return r
      }
    })
  }

  protected get statuses() {
    const arr: string[] = []
    this.reports.forEach((r) => {
      const s = r.status
      if (!arr.includes(s)) {
        arr.push(s)
      }
    })
    return arr
  }

  protected openVehicleReport(report: any) {
    this.openPopup(new PopupState(VehicleReport, {report}, this.$t('vehicle.report.diary_report')))
  }

  protected getCreated(time: string) { // not in use
    const date: any = DateHelper.parse(time)
    return `${date.format('LT')}<br>${date.format('L')}`
  }

  protected statusFormat(r: Report) {
    const s = r.status

    let color = 'accent'

    switch (s) {
      case 'CONFIRMED':
      case 'RESOLVED':
        color = 'success'
        break
      case 'PENDING_REVIEW':
        color = 'warning'
        break
      case 'VOIDED':
        color = 'grey'
    }

    return {
      text: this.$t(`vehicle.report.status.${s.toLowerCase()}`),
      color: color + '--text',
    }
  }

  protected addReport() {
    this.openPopup(new PopupState(VehicleAddReport, {vehicle: null}, this.$t('vehicle.report.diary_report')))
  }

  protected created() {
    this.show = this.statuses
  }
}
